import {MapMeta as ApiMapMeta} from "../API";
import {CollaboratorType, isCollaboratorType} from "./Collaboration/Collaborator";


export const MAP_VERSION1 = 1;
export const MAP_VERSION2 = 2;

export type MapVersion = 1 | 2;


export class MapMeta {

    private readonly map_id: string;
    private readonly version: MapVersion;
    private readonly collaborator_type: CollaboratorType;


    constructor(map_id: string, version: MapVersion, collaborator_type: CollaboratorType) {
        this.map_id = map_id;
        this.version = version;
        this.collaborator_type = collaborator_type;
    }

    get MapId() {
        return this.map_id;
    }

    get Version(): MapVersion {
        return this.version;
    }

    get CollaboratorType(): CollaboratorType {
        return this.collaborator_type;
    }

    isOwner(): boolean {
        return this.collaborator_type === 'owner';
    }

    isEditable(): boolean {
        return (this.collaborator_type === 'owner' || this.collaborator_type === 'editor');
    }

    isReadOnly(): boolean {
        return !this.isEditable();
    }

    static fromApi(meta: ApiMapMeta): MapMeta {
        if (meta.version !== MAP_VERSION1 && meta.version !== MAP_VERSION2) {
            throw new Error("unknown map version");
        }

        if (!isCollaboratorType(meta.collaboratorType)) {
            throw new Error("unknown collaborator type");
        }
        return new MapMeta(meta.mapId, meta.version, meta.collaboratorType);
    }

    static createReadOnly(map_id: string): MapMeta {
        return new MapMeta(map_id, MAP_VERSION2, 'viewer');
    }
}
